export function normalizeDiscountData(raw) {
  const normalizedType = raw.type === "Percentage"
    ? "percentage"
    : raw.type === "Fixed amount"
    ? "fixed"
    : "percentage";

  return {
    // General Info Section
    discountName: raw.name || "",
    discountType: normalizedType,
    discountCode: raw.code || "",
    discountValue: raw.value ?? 0,
    autoApplyDiscount: raw.autoApply ?? false,

    // Schedule Section
    discountStartDate: raw.startDate ? new Date(raw.startDate).toISOString().slice(0, 16) : "",
    discountEndDate: raw.endDate ? new Date(raw.endDate).toISOString().slice(0, 16) : "",
  };
}
